/* ============================================================
   Curious PDP — gallery thumb switching, variant-image swap,
   swipe gestures on hero, lightbox with pinch/zoom/pan,
   keyboard navigation, idle preload of all variant images.
   ============================================================ */

(function () {
  'use strict';

  // ---- DOM helpers --------------------------------------------------
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // ---- Gallery state ------------------------------------------------
  var pdp = $('[data-curious-pdp]');
  if (!pdp) return;
  var thumbs = $$('[data-curious-thumb]', pdp);
  var heroImgs = $$('[data-curious-hero-img]', pdp);
  var heroFrame = $('.curious-pdp__hero-frame', pdp);
  var currentIndex = 0;

  function showImageAt(idx) {
    if (idx < 0) idx = heroImgs.length - 1;
    if (idx >= heroImgs.length) idx = 0;
    currentIndex = idx;
    var target = heroImgs[idx];
    var swap = function () {
      heroImgs.forEach(function (img, i) {
        img.style.display = i === idx ? 'block' : 'none';
      });
    };
    // Decode first if available to avoid paint flicker
    if (target && typeof target.decode === 'function' && !target.complete) {
      target.decode().then(swap).catch(swap);
    } else {
      swap();
    }
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    var matchThumb = thumbs.find(function (t) {
      return parseInt(t.getAttribute('data-curious-thumb'), 10) === idx;
    });
    if (matchThumb) {
      matchThumb.classList.add('is-active');
      // Keep active thumb in view inside the horizontal strip
      var track = matchThumb.closest('[data-curious-thumbs-track]') || matchThumb.parentElement;
      if (track && track.scrollWidth > track.clientWidth) {
        var tRect = track.getBoundingClientRect();
        var mRect = matchThumb.getBoundingClientRect();
        var pad = 16;
        if (mRect.left < tRect.left + pad) {
          track.scrollBy({ left: mRect.left - tRect.left - pad, behavior: 'smooth' });
        } else if (mRect.right > tRect.right - pad) {
          track.scrollBy({ left: mRect.right - tRect.right + pad, behavior: 'smooth' });
        }
      }
    }
  }

  // Idle preload all images — keeps swatch hops snappy
  function preloadAllImages() {
    var run = function () {
      heroImgs.forEach(function (img) {
        var src = img.getAttribute('src');
        if (src) {
          var i = new Image();
          i.src = src;
        }
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 1500);
  }
  preloadAllImages();

  // Thumb click → show
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.getAttribute('data-curious-thumb'), 10);
      showImageAt(idx);
    });
  });

  // Prev/Next arrow buttons
  var prevBtn = $('[data-curious-prev]', pdp);
  var nextBtn = $('[data-curious-next]', pdp);
  if (prevBtn) prevBtn.addEventListener('click', function () { showImageAt(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showImageAt(currentIndex + 1); });

  // Thumb-strip scroll buttons (desktop) — only visible when track overflows
  var thumbsWrap = $('[data-curious-thumbs-wrap]', pdp);
  var thumbsTrack = $('[data-curious-thumbs-track]', pdp);
  var thumbsPrev = $('[data-curious-thumbs-prev]', pdp);
  var thumbsNext = $('[data-curious-thumbs-next]', pdp);
  function syncThumbsOverflow() {
    if (!thumbsWrap || !thumbsTrack) return;
    var overflows = thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 4;
    thumbsWrap.setAttribute('data-curious-thumbs-overflow', overflows ? '1' : '0');
  }
  if (thumbsTrack) {
    syncThumbsOverflow();
    window.addEventListener('resize', syncThumbsOverflow);
    if (thumbsPrev) thumbsPrev.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: -thumbsTrack.clientWidth * 0.8, behavior: 'smooth' });
    });
    if (thumbsNext) thumbsNext.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: thumbsTrack.clientWidth * 0.8, behavior: 'smooth' });
    });
  }

  // ---- Swipe on hero (mobile/touch) --------------------------------
  if (heroFrame) {
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeStartT = 0;
    heroFrame.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
      swipeStartT = Date.now();
    }, { passive: true });
    heroFrame.addEventListener('touchend', function (e) {
      if (!swipeStartT) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - swipeStartX;
      var dy = t.clientY - swipeStartY;
      var dt = Date.now() - swipeStartT;
      swipeStartT = 0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4 && dt < 700) {
        if (dx < 0) showImageAt(currentIndex + 1);
        else showImageAt(currentIndex - 1);
      }
    }, { passive: true });
  }

  // ---- Variant-image swatch swap -----------------------------------
  // Map variant.id → image src by reading product.variants JSON
  var variantsScript = $('[data-curious-variants]', pdp);
  var variantsList = [];
  try { variantsList = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : []; }
  catch (e) { variantsList = []; }

  function findHeroIndexByMediaId(mid) {
    if (!mid) return -1;
    var key = String(mid);
    for (var i = 0; i < heroImgs.length; i++) {
      if (heroImgs[i].getAttribute('data-curious-media-id') === key) return i;
    }
    return -1;
  }
  function findHeroIndexByPosition(pos) {
    if (!pos) return -1;
    var key = String(pos);
    for (var i = 0; i < heroImgs.length; i++) {
      if (heroImgs[i].getAttribute('data-curious-position') === key) return i;
    }
    return -1;
  }
  function findHeroIndexBySrc(src) {
    if (!src) return -1;
    // Strip query string + Shopify size suffix (_NNNNx) so the basename matches
    // regardless of which width was requested for the gallery vs variant image.
    function basename(u) {
      return u.split('?')[0].split('/').pop().replace(/_\d+x(?=\.[a-z]+$)/i, '');
    }
    var target = basename(src);
    for (var i = 0; i < heroImgs.length; i++) {
      var s = heroImgs[i].getAttribute('src') || '';
      if (basename(s) === target) return i;
    }
    return -1;
  }

  // Attach to swatch radio inputs + opt-btns. When user changes a value,
  // look up the matching variant; if it has a featured_image, swap hero.
  function getCurrentVariant() {
    var hidden = $('[data-curious-variant-id]', pdp);
    if (!hidden) return null;
    var id = parseInt(hidden.value, 10);
    return variantsList.find(function (v) { return v.id === id; });
  }
  function syncToCurrentVariant() {
    var v = getCurrentVariant();
    if (!v || !v.featured_image) return;
    var fi = v.featured_image;
    var idx = findHeroIndexByMediaId(fi.id);
    if (idx < 0) idx = findHeroIndexByPosition(fi.position);
    if (idx < 0) {
      var src = fi.src || (typeof fi === 'string' ? fi : null);
      if (src) idx = findHeroIndexBySrc(src);
    }
    if (idx >= 0) {
      showImageAt(idx);
      // Mobile: scroll back to hero so user sees the new image
      if (window.innerWidth < 900 && heroFrame) {
        heroFrame.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
  // Watch the hidden id input — variant picker JS in the section updates it.
  var hidden = $('[data-curious-variant-id]', pdp);
  if (hidden) {
    hidden.addEventListener('curious:variant:change', syncToCurrentVariant);
    // Sync once on load so hero matches the pre-selected variant (color/size combo)
    syncToCurrentVariant();
  }

  // ---- Lightbox ----------------------------------------------------
  function openLightbox(startIdx) {
    if (heroImgs.length === 0) return;

    var lb = document.createElement('div');
    lb.className = 'curious-lightbox is-open';
    lb.innerHTML =
      '<div class="curious-lightbox__stage" data-stage>' +
        '<img class="curious-lightbox__img" data-img alt="">' +
      '</div>' +
      '<button type="button" class="curious-lightbox__close" data-close aria-label="Close">×</button>' +
      (heroImgs.length > 1
        ? '<button type="button" class="curious-lightbox__nav curious-lightbox__nav--prev" data-prev aria-label="Previous">‹</button>' +
          '<button type="button" class="curious-lightbox__nav curious-lightbox__nav--next" data-next aria-label="Next">›</button>' +
          '<div class="curious-lightbox__counter" data-counter></div>'
        : '');
    document.body.appendChild(lb);
    document.body.classList.add('curious-lightbox-open');

    var stage = lb.querySelector('[data-stage]');
    var img = lb.querySelector('[data-img]');
    var counter = lb.querySelector('[data-counter]');
    var idx = startIdx || 0;
    var scale = 1, tx = 0, ty = 0;
    var pinchStartDist = 0, pinchStartScale = 1;
    var panStartX = 0, panStartY = 0, panStartTx = 0, panStartTy = 0;

    function getHi(idx) {
      // Try data-zoom-src else fallback to src
      return heroImgs[idx].getAttribute('data-zoom-src') || heroImgs[idx].getAttribute('src');
    }
    function render() {
      img.src = getHi(idx);
      img.alt = heroImgs[idx].getAttribute('alt') || '';
      if (counter) counter.textContent = (idx + 1) + ' / ' + heroImgs.length;
      scale = 1; tx = 0; ty = 0; applyTransform();
    }
    function applyTransform() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      stage.classList.toggle('is-zoomed', scale > 1.05);
    }
    function next() { idx = (idx + 1) % heroImgs.length; render(); }
    function prev() { idx = (idx - 1 + heroImgs.length) % heroImgs.length; render(); }
    function close() {
      document.body.classList.remove('curious-lightbox-open');
      lb.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    }

    lb.querySelector('[data-close]').addEventListener('click', close);
    lb.addEventListener('click', function (e) {
      if (e.target === lb) close();
    });
    var prevBtn = lb.querySelector('[data-prev]');
    var nextBtn = lb.querySelector('[data-next]');
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    document.addEventListener('keydown', onKey);

    // Double-tap to zoom toggle (and to reset)
    var lastTap = 0;
    stage.addEventListener('click', function () {
      var now = Date.now();
      if (now - lastTap < 350) {
        scale = scale > 1.05 ? 1 : 2;
        tx = 0; ty = 0;
        applyTransform();
      }
      lastTap = now;
    });

    // Pinch zoom + pan (touch)
    function dist(t1, t2) {
      var dx = t1.clientX - t2.clientX;
      var dy = t1.clientY - t2.clientY;
      return Math.hypot(dx, dy);
    }
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinchStartDist = dist(e.touches[0], e.touches[1]);
        pinchStartScale = scale;
      } else if (e.touches.length === 1 && scale > 1.05) {
        stage.classList.add('is-panning');
        panStartX = e.touches[0].clientX;
        panStartY = e.touches[0].clientY;
        panStartTx = tx; panStartTy = ty;
      } else if (e.touches.length === 1) {
        // potential swipe-to-navigate
        panStartX = e.touches[0].clientX;
        panStartY = e.touches[0].clientY;
      }
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchStartDist > 0) {
        var d = dist(e.touches[0], e.touches[1]);
        scale = Math.max(1, Math.min(4, pinchStartScale * (d / pinchStartDist)));
        if (scale <= 1.05) { tx = 0; ty = 0; }
        applyTransform();
        e.preventDefault();
      } else if (e.touches.length === 1 && scale > 1.05) {
        tx = panStartTx + (e.touches[0].clientX - panStartX);
        ty = panStartTy + (e.touches[0].clientY - panStartY);
        applyTransform();
        e.preventDefault();
      }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      stage.classList.remove('is-panning');
      pinchStartDist = 0;
      // Swipe-to-navigate when not zoomed
      if (scale <= 1.05 && e.changedTouches.length === 1) {
        var dx = e.changedTouches[0].clientX - panStartX;
        var dy = e.changedTouches[0].clientY - panStartY;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          if (dx < 0) next(); else prev();
        }
      }
    }, { passive: true });

    render();
  }

  // Click hero image to open lightbox at the current index
  if (heroFrame) {
    heroFrame.addEventListener('click', function (e) {
      // Only open on click of an image (not the sticker, controls, blobs)
      var img = e.target.closest && e.target.closest('.curious-pdp__hero-img');
      if (img) openLightbox(currentIndex);
    });
    heroFrame.style.cursor = 'zoom-in';
  }
})();
